/**
 * Core Models Barrel Export
 *
 * Note: Selective exports to avoid naming conflicts
 */

// User model exports
export { User, UserRoleHelper } from './user.model';

// Custom claims exports (includes MembershipRoles as canonical source)
export {
  CustomClaims,
  ClaimMembership,
  CustomClaimsData,
  ClaimMembershipData,
  GlobalRoles,
  MatchType,
  MembershipRoles
} from './custom-claims.model';

// Profile model exports
export * from './profile.model';

// Organization model exports
export * from './organization.model';

// Safety test model exports
export * from './safety-test.model';

// FAA report model exports
export * from './faa-report.model';

// Chemical model exports
export * from './chemical.model';

// Membership model exports (MembershipRoles exported from custom-claims.model above)
export {
  AdminMemberView,
  MemberDetails,
  MemberCertification,
  MemberActivity,
  MemberOrganization,
  InvitationEmailStatus,
  PendingInvitation,
  MemberStats,
  InvitationStats,
  RoleHelper
} from './membership.model';

// Drone model exports
export * from './drone.model';

// Drone resource model exports
export * from './drone-resource.model';

// Unassigned ticket model exports
export * from './unassigned-ticket.model';
